"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWrapper = exports.PageContext = void 0;
const react_1 = __importStar(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const theme_selector_1 = require("../theme-selector");
exports.PageContext = (0, react_1.createContext)({
    componentsMap: {},
    deviceType: monera_app_core_1.DeviceType.Desktop,
    pageType: monera_app_core_1.PageType.DetailPage
});
const PageWrapper = (props) => {
    const { children, tenantTheme, componentsMap, deviceType, pageType } = props;
    return (react_1.default.createElement(exports.PageContext.Provider, { value: { componentsMap, deviceType, pageType } },
        react_1.default.createElement(theme_selector_1.ThemeSelector, { theme: tenantTheme }, children)));
};
exports.PageWrapper = PageWrapper;
